import React from 'react';
import ManageTeamForm from '../Forms/manage_team_form';
import { ManageDataPage } from './manageDataShared';

const COLUMNS = [
    { label: 'Name', field: 'Name' },
    { label: 'Email', field: 'Email' },
    { label: 'Address', field: 'Address' },
    { label: 'Contact No.', field: 'ContactNo' },
    { label: 'Username', field: 'Username' },
];

function Manage_team() {
    return (
        <ManageDataPage
            title="Manage Team"
            endpoint="get_manage_team_table"
            columns={COLUMNS}
            editable={false}
            FormComponent={ManageTeamForm}
            searchPlaceholder="Search name, email, username..."
        />
    );
}

export default Manage_team;
